import React from 'react';
import ExpandableContainer from '../ExpandableContainer';
import * as Row from '../../../layout/Row';

export default class HeatPumpConnections extends React.Component {
    render() {
        if (!this.props.fields.heatPumpConnectionsIncluded.value) {
            return <React.Fragment/>
        }

        const warnings = [
            this.props.fields.connectionTypeDN.warning,
            this.props.fields.nonReturnValveHeatingSupply.warning,
            this.props.fields.nonReturnValveHPReturn.warning,
            this.props.fields.threeWayValve.warning,
            this.props.fields.balancingValveHPSupply.warning,
            this.props.fields.separateHeatExchanger.warning];

        return (
            <ExpandableContainer warnings={warnings} label={__('Heat pump connections')}>
                <Row.Container hasOuterGutter={false}>
                    <div className="column-6 column-xs-12"
                         hidden={
                             !this.props.fields.connectionTypeDN.visible &&
                             !this.props.fields.nonReturnValveHeatingSupply.visible &&
                             !this.props.fields.nonReturnValveHPReturn.visible
                         }>
                        {this.props.renderGenericHorizontalField(this.props.fields.connectionTypeDN)}
                        {this.props.renderGenericHorizontalField(this.props.fields.nonReturnValveHeatingSupply)}
                        {this.props.renderGenericHorizontalField(this.props.fields.nonReturnValveHPReturn)}
                    </div>
                    <div className="column-6 column-xs-12"
                         hidden={
                             !this.props.fields.threeWayValve.visible &&
                             !this.props.fields.balancingValveHPSupply.visible &&
                             !this.props.fields.separateHeatExchanger.visible
                         }>
                        {this.props.renderGenericHorizontalField(this.props.fields.threeWayValveManufacturer)}
                        {this.props.renderGenericHorizontalField(this.props.fields.threeWayValveSize)}
                        {this.props.renderGenericHorizontalField(this.props.fields.threeWayValve)}
                        {this.props.renderGenericHorizontalField(this.props.fields.balancingValveHPSupply)}
                        {this.props.renderGenericHorizontalField(this.props.fields.separateHeatExchanger)}
                    </div>
                </Row.Container>
            </ExpandableContainer>
        )
    }
}